// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"clientDetailMain_mainContent__3r2O_","content":"clientDetailMain_content__24TOt","links":"clientDetailMain_links__KnWHI"};